import { AyudantiaInvestigacion } from "./AyudantiaInvestigacion"

export interface SolicitudAyudanteInv{
    idsolicitud: number,
    idproyecto: number,
    descripcion: string,
    termino: string,
    horas: string,
    actividades: string,
    docente: string,
    tipofinanciamiento: string
}

export function voidSolicitudAyudanteInv() : SolicitudAyudanteInv {
    return{
    idsolicitud: 0,
    idproyecto: 0,
    descripcion: '',
    termino: '',
    horas: '',
    actividades: '',
    docente: '',
    tipofinanciamiento: ''
    }
    
}
export function setSolicitudAyudanteInv(data: any): SolicitudAyudanteInv  {
    return {
    idsolicitud: data.idsolicitud??'',
    idproyecto: data.idproyecto??'',    
    descripcion: data.descripcion??'',
    termino: data.termino??'',
    horas: data.horas??'',
    actividades: data.actividades??'',
    docente: data.docente??'',
    tipofinanciamiento: data.tipofinanciamiento??'',
    }
}

export function CastAyudanteInvestigacionToSolicitudAyudanteInv(ayudantia: AyudantiaInvestigacion):SolicitudAyudanteInv{
    return {
        idsolicitud: ayudantia.proyectoAyud.iddecinvproyectoayud??0,
        idproyecto: ayudantia.proyectoAyud.iddecinvproyecto,    
        descripcion: ayudantia.proyectoAyud.descripcion,
        termino: ayudantia.proyectoAyud.termino,
        horas: (ayudantia.proyectoAyud.horas??0).toString(),
        actividades: ayudantia.proyectoAyud.actividades,
        docente: ayudantia.proyectoAyud.mailresponsable,
        tipofinanciamiento: (ayudantia.proyectoAyud.financiamientoayudante??0).toString(),
        }
}

